var irreducible = require('./irreducible');

module.exports = irreducible('Any', function () { return true; });



//////////////////
// WEBPACK FOOTER
// /produit/nodejs/bin/node-v14.19.0-linux-x64/lib/~/tcomb/lib/Any.js
// module id = 227
// module chunks = 0